import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import {
  Collapse,
  Tag,
  Modal,
  Timeline,
  Radio,
  Input,
  Select,
  Empty,
  message,
} from "antd";
const { Panel } = Collapse;
import moment from "moment";
import "./index.scss";
import InspectionApi from "@api/inspectionnew";

const Pedding = (props) => {
  const [agree, setAgree] = useState(1);
  const [refuseText] = useState();
  const [refuseTextVisi] = useState(false);
  const [ModalVisible, setModalVisible] = useState(false);
  const [todoList, setTodoList] = useState([]);
  const [todoLength, setTodoLength] = useState("0");
  const [personLs, setPersonLs] = useState([]);
  const [approvalLs, setApprovalLs] = useState([]);
  const [remark, setRemark] = useState();
  const [taskId, setTaskId] = useState();

  useEffect(() => {
    getList();
  }, []);

  const getList = () => {
    InspectionApi.todoList({}).then((res) => {
      if (res.status !== "0") return;
      setTodoLength(res.data.length + "");
      setTodoList(res.data);
    });
  };

  const onChange = (e) => {
    // console.log(e)
  };

  // 查看详情
  const lookDetail = (id, taskId) => {
    InspectionApi.todoDetail({ id }).then((res) => {
      if (res.status !== "0") return;
      if (res.data.length > 0) {
        const ary = res.data.map((item) => item.userName);
        setPersonLs(ary);
        setApprovalLs(res.data);
      }
      setTaskId(taskId);
      setModalVisible(true);
    });
  };

  // 提交审核
  const submiteApproval = () => {
    const userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    const params = {
      taskId,
      approved: agree,
      userName: userInfo.name,
      tenantId: userInfo.tenantId,
      uid: userInfo.id,
    };
    if (!agree) {
      // 拒绝参数
      params.remark = remark;
      if (!remark) return message.error("备注不能为空");
    }
    InspectionApi.completeTask(params).then((res) => {
      if (res.status !== "0") return;
      message.success("审批成功");
      setModalVisible(false);
      setRemark("");
      setAgree(1);
      getList();
    });
  };

  return (
    <div className="pedding-container">
      <div className="pedding-ls">
        <Collapse
          defaultActiveKey={["1"]}
          onChange={onChange}
          expandIconPosition="right"
        >
          <Panel header="审批待办" key="1" extra={todoLength}>
            {todoList.length > 0 ? (
              <div>
                {todoList.map((item, index) => (
                  <p key={item.id}>
                    审批内容{index + 1}：{item.name}
                    <Tag
                      onClick={() => lookDetail(item.id, item.taskId)}
                      style={{ marginLeft: "5px" }}
                      color="#108ee9"
                    >
                      审批
                    </Tag>
                  </p>
                ))}
              </div>
            ) : (
              <Empty description="暂无待办" />
            )}
          </Panel>
        </Collapse>
      </div>
      <Modal
        title="审批流程"
        open={ModalVisible}
        onOk={submiteApproval}
        onCancel={() => setModalVisible(false)}
      >
        <div className="approval-progress">
          <Timeline style={{ marginTop: "8px" }}>
            {personLs.length > 0 &&
              personLs.map((item, index) => (
                <Timeline.Item key={index}>{item}</Timeline.Item>
              ))}
          </Timeline>
          <div className="approval-content">
            {approvalLs.length > 0 &&
              approvalLs.map((item, index) => (
                <div className="approval-content-item" key={index}>
                  <p>时间：{moment(item.time).format("YYYY-MM-DD HH:mm:ss")}</p>
                  <p>审批人: {item.userName}</p>
                  <p>状态：{item.status ? "已审" : "未审"}</p>
                </div>
              ))}
            <div className="approval-choose">
              <div className="approval-choose-item">
                <Radio.Group
                  style={{ marginTop: "15px" }}
                  onChange={(e) => setAgree(e.target.value)}
                  value={agree}
                >
                  <Radio value={1}>同意</Radio>
                  <Radio value={0}>拒绝</Radio>
                </Radio.Group>
                {agree === 0 && (
                  <Input
                    style={{ marginTop: 10 }}
                    placeholder="请输入备注"
                    onChange={(e) => setRemark(e.target.value)}
                    value={remark}
                  />
                )}
              </div>
              {refuseTextVisi && (
                <>
                  <div className="approval-choose-item">
                    <Select
                      style={{ width: "100%" }}
                      placeholder="请选择驳回到岗位几"
                    >
                      <Select.Option value={1}>岗位1</Select.Option>
                      <Select.Option value={2}>岗位2</Select.Option>
                    </Select>
                  </div>
                  <div className="approval-choose-item">
                    <Input value={refuseText} placeholder="请输入驳回原因" />
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    ...state.Common,
  };
};

export default connect(mapStateToProps)(Pedding);
